const noop = () => { };
const show = {};
if (localStorage.log)
    localStorage.log.split(/, ?/).forEach((key) => (show[key] = true));
const showAll = show['*'];
const log = (showAll ? console.log.bind(console) : noop);
log.tag = tag;
log.tagColor = tagColor;
export default log;
function tag(tag, ...args) {
    if (!showAll && !show[tag])
        return noop;
    if (args.length) {
        console.log(`%c[${tag}]`, 'font-weight:bold', ...args);
    }
    else {
        return console.log.bind(console, `[${tag}]`, 'font-weight:bold');
    }
}
function tagColor(tag, color, ...args) {
    if (!showAll && !show[tag])
        return noop;
    if (args.length) {
        console.log(`%c[${tag}]`, 'font-weight:bold;color:' + color, ...args);
    }
    else {
        return console.log.bind(console, `%c[${tag}]`, 'font-weight:bold;color:' + color);
    }
}
